module.exports = __webpack_public_path__ + "static/MenusJson-22f88e1a72bee3da13232545954e6c5b.png";